export const CREATE_ASSISTANT = gql`
  mutation CreateAssistant($assistantInput: AssistantInput!) {
    createAssistant(assistantInput: $assistantInput) {
      id
    }
  }
`

export const DELETE_ASSISTANT = gql`
  mutation DeleteAssistant($workspaceId: String!, $assistantId: String!) {
    deleteAssistant(workspaceId: $workspaceId, assistantId: $assistantId)
  }
`

export const UPDATE_ASSISTANT = gql`
  mutation UpdateAssistant(
    $assistantId: String!
    $assistantInput: AssistantInput!
    $workspaceId: String!
  ) {
    updateAssistant(
      assistantId: $assistantId
      assistantInput: $assistantInput
      workspaceId: $workspaceId
    ) {
      id
    }
  }
`

export const CREATE_ASSISTANT_TIER = gql`
  mutation CreateAssistantTier($tierInput: AssistantTierInput!) {
    addTier(tierInput: $tierInput) {
      id
    }
  }
`

export const UPDATE_ASSISTANT_TIER = gql`
  mutation UpdateAssistantTier(
    $tierId: String!
    $tierInput: AssistantTierInput!
  ) {
    updateTier(tierId: $tierId, tierInput: $tierInput) {
      id
    }
  }
`

export const TEST_ASSISTANT_SCHEDULE = gql`
  mutation TestAssistantSchedule($scheduleId: String!, $workspaceId: String!) {
    testAssistantSchedule(scheduleId: $scheduleId, workspaceId: $workspaceId)
  }
`
